interface WhatsappIconProps {
  fill?: string;
}

const WhatsappIcon: React.FC<WhatsappIconProps> = ({ fill = "#015C9A" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_417_389)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 1.33333C4.8181 1.33333 1.83333 4.3181 1.83333 8C1.83333 9.2154 2.15797 10.353 2.72481 11.3329L2.85736 11.562L2.79661 11.8197C2.61609 12.5853 2.54527 12.9919 2.45175 13.5289C2.42189 13.7004 2.38972 13.8851 2.35092 14.0991C2.8447 13.9746 3.2832 13.8635 3.67531 13.7641C3.95389 13.6935 4.20905 13.6288 4.44398 13.5695L4.7202 13.4998L4.9615 13.6512C5.98655 14.2946 7.1988 14.6667 8.5 14.6667C12.1819 14.6667 15.1667 11.6819 15.1667 8C15.1667 4.3181 12.1819 1.33333 8.5 1.33333ZM0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C7.04446 16 5.67807 15.6107 4.50119 14.9303C4.34481 14.9699 4.17969 15.0117 4.00516 15.056C3.36276 15.2188 2.59286 15.414 1.66171 15.6468L0.639694 15.9023L0.8463 14.8693C0.977716 14.2122 1.05816 13.754 1.12915 13.3497C1.21959 12.8345 1.2947 12.4067 1.44035 11.7662C0.840126 10.6433 0.5 9.36047 0.5 8Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.55113 4.61362C6.39029 4.22732 6.22691 4.27959 6.10527 4.27353C5.98982 4.26779 5.85758 4.26657 5.72547 4.26657C5.59337 4.26657 5.37869 4.31615 5.19703 4.51446C5.01539 4.71279 4.50348 5.19207 4.50348 6.16713C4.50348 7.14219 5.21355 8.08419 5.31264 8.21641C5.41171 8.34863 6.70999 10.3496 8.69787 11.2077C9.17065 11.4118 9.53979 11.5337 9.82757 11.625C10.3023 11.7758 10.7343 11.7545 11.0758 11.7035C11.4565 11.6467 12.2482 11.2243 12.4133 10.7615C12.5785 10.2988 12.5785 9.90212 12.5289 9.81948C12.4794 9.73687 12.3473 9.68728 12.1491 9.58811C11.9509 9.48896 10.9767 9.00967 10.795 8.94358C10.6134 8.87748 10.4813 8.84443 10.3492 9.04275C10.2171 9.24105 9.83729 9.68728 9.72169 9.81948C9.60611 9.9517 9.49051 9.96824 9.29236 9.86907C9.09419 9.76992 8.45567 9.56071 7.69876 8.88581C7.10968 8.36055 6.71194 7.71175 6.59635 7.51343C6.48075 7.31511 6.58405 7.20788 6.68325 7.10913C6.77239 7.02038 6.88141 6.87776 6.98049 6.76207C7.07957 6.64639 7.1126 6.56375 7.17865 6.43155C7.24471 6.29933 7.21167 6.18365 7.16213 6.08449C7.11259 5.98533 6.71628 5.01025 6.55113 4.61362Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_417_389">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WhatsappIcon;
